import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { LoginComponent } from './account/login.component';
import { CoursewareService } from 'src/services/CoursewareService';
import { AlertService } from './_alert';
import { globals } from './shared/globals';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent {
  title = 'Lawshelf';
  timeZone = "";
  subtractHours = 0;
  public isServer: boolean = true;

  constructor(@Inject(DOCUMENT) private document, private _router: Router, private coursewareService: CoursewareService, private alertService: AlertService) {

    let theUrl = "https://lawshelf.com";
    if (this.document && this.document.location && this.document.location.hostname && this.document.location.hostname.length > 3) {
      this.document.location.protocol + "//" + this.document.location.hostname + ":" + this.document.location.port;
      if (!this.document.location.port)
        theUrl = this.document.location.protocol + "//" + this.document.location.hostname;
    }
    globals.LOCALHOST = theUrl;
    this.getHours();
    if (typeof window !== 'undefined') {
      this.isServer = false;
      globals.token = localStorage.getItem("token");
      globals.userName = localStorage.getItem("username");
      globals.LOCALHOST = window.location.origin;

      //      if(window.navigator && navigator.serviceWorker) {
      //        navigator.serviceWorker.getRegistrations().then(function (registrations) {
      //          for (const registration of registrations) {
      //            console.log('serviceWorker unregistered');
      //            registration.unregister();
      //          }
      //        });
      //      }
      //this._router.events.subscribe(event => {
      //  if (event instanceof NavigationEnd) {
      //    (<any>window).gtag('config', 'UA-103104789-1', { 'page_path': event.urlAfterRedirects });
      //  }
      //});
    }
  }

  public getUserName() {
    if (globals.userName)
      return globals.userName;
    return null;
  }

  public getYear() {
    return (new Date()).getFullYear()
  }

  public getHours() {
    var offset = new Date().getTimezoneOffset();
    this.timeZone = "";
    if (offset < 300)
      offset = 300;
    else if (offset > 480)
      offset = 480;
    this.subtractHours = offset / 60 - 5;
    switch (offset) {
      case 300:
        this.timeZone = "EST";
        break;
      case 360:
        this.timeZone = "CST";
        break;
      case 420:
      default:
        this.timeZone = "MST";
        break;
      case 480:
        this.timeZone = "PST";
        break;
    }
  }

  getWeekdayHours() {
    return ((9 - this.subtractHours) + ":00 am - " + (8 - this.subtractHours) + ":00 pm (" + this.timeZone + ")");
  }

  getFridayHours() {
    return ((11 - this.subtractHours) + ":00 am - " + (6 - this.subtractHours) + ":30 pm (" + this.timeZone + ")");
  }

  getSundayHours() {
    return ((9 - this.subtractHours) + ":00 am - " + (((4 - this.subtractHours) == 0) ? 12 : (3 - this.subtractHours)) + ":30 pm (" + this.timeZone + ")");
  }

  public doLogout() {
    LoginComponent.user = null;
    this.coursewareService.Logout(globals.token).subscribe(data => {
      globals.userName = null;
      if (typeof window !== 'undefined') {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
      }
    });
  }
}